export default __webpack_public_path__ + "static/media/user.302b443c.svg";